<template>
  <b-modal id="deadline-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" @hide="$emit('closeDeadlineModal', activity.activityId)">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('voc.create_deadline') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-p adp-p__grey" style="margin-top: -16px;">{{ activity.name }}</div>
      <div class="adp-modal-row d-flex flex-column">
        <label class="adp-p adp-p__grey">{{ $t('catalog.set_deadline') }}</label>
        <my-date-picker @change="changeDateInterval($event)"
                        :dates="deadline"
                        :disabled-before="disabledBefore"
                        :disabled-after="disabledAfter">
        </my-date-picker>
      </div>
    </template>
    <template #modal-footer>
      <button class="btn adp-btn adp-btn__dark-grey adp-btn__large" @click="skip()">
        {{ $t('voc.skip') }}
      </button>
      <button class="btn adp-btn adp-btn__large"
              :class="{'disabled': !deadline}"
              :disabled="!deadline"
              @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import MyDatePicker from "../MyDatePicker";
import api from "../../api";

export default {
  name: "DeadlineModal",
  components: {
    'my-date-picker': MyDatePicker,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    idpStatus: {
      type: String,
      required: true,
    }
  },
  data: function () {
    return {
      deadline: null,
    }
  },
  computed: {
    disabledBefore() {
      if (this.activity.start_at) {
        return new Date(this.activity.start_at);
      }
      if (this.idpStatus === 'agreed_by_manager') {
        return new Date();
      }

      return new Date((new Date()).getFullYear() + 1, 0, 1);
    },
    disabledAfter() {
      if (this.activity.end_at) {
        return new Date(this.activity.end_at);
      }
      return null;
    }
  },
  methods: {
    onShow() {
    },
    changeDateInterval(e) {
      if (e === null) {
        return;
      }
      this.deadline = e;
    },
    async save() {
      this.$emit('setDeadline', this.activity.activityId, new Date(this.deadline).toLocaleString());
    },
    async skip() {
      const deadline = this.activity.end_at ? new Date(this.activity.end_at).toLocaleString() : null;
      this.$emit('setDeadline', this.activity.activityId, deadline);
    },
  },
}
</script>
